import { defineMessages } from 'react-intl';

export default defineMessages({
	sendForm: {
		defaultMessage: 'Send',
		description: 'Send button for request create form',
		id: 'cv.request.create.form.button.send',
	},
	cancelForm: {
		defaultMessage: 'Cancel',
		description: 'Cancel button for request create form',
		id: 'cv.request.create.form.button.cancel',
	},
	fieldValidationError: {
		defaultMessage: `Please provide a value for required field \u2019{fieldLabel}\u2019`,
		description: 'Field error validation message shown under field when there is an error.',
		id: 'cv.request.create.field.validation.error.message',
	},
	fieldLimitExceededError: {
		defaultMessage: `This field can only store {objectLimit, plural, one {# object} other {# objects}}.`,
		description:
			'Field error validation message shown under field when the field limit is exceeded.',
		id: 'cv.request.create.field.limit.exceeded.error.message',
	},
	fieldInvalidConfigError: {
		defaultMessage:
			'This required field is missing configuration and therefore cannot be displayed.',
		description:
			'Field error validation message shown under field when the field does not have a valid configuration.',
		id: 'cv.request.create.field.invalid.config.error.message',
	},
	affectedServicesFieldLimitError: {
		defaultMessage:
			'This field can only store a maximum of {serviceLimit, plural, one {# service} other {# services}}.',
		description:
			'Field error validation message shown under field when the field limit is exceeded.',
		id: 'cv.request.create.field.affected-services.limit.exceeded.error.message',
	},
	thanksTitle: {
		defaultMessage: 'Thanks',
		description: 'Header message for a page after they have successfully created a request.',
		id: 'cv.request.create.embeddable.create.success.title',
	},
	referenceDescription: {
		defaultMessage: 'Your request has been raised.',
		description: 'Description message for a page after they have successfully created a request.',
		id: 'cv.request.create.embeddable.create.success.description',
	},
	callToAction: {
		defaultMessage: 'View request',
		description:
			'Call to action link that takes the user the help center in a new tab, after they have successfully created a request.',
		id: 'cv.request.create.embeddable.create.success.callToActionText',
	},
	instructionForMandatoryField: {
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'This is an instruction which states fields with an asterisk (*) are compulsary',
		id: 'cv.request.create.embeddable.instructionForMandatoryField',
	},
	requestSubmittedMessage: {
		defaultMessage: 'Request submitted successfully',
		description: 'The title shown in the flag when the request is submitted successfully',
		id: 'help-center.request-create-form.requestSubmittedMessage',
	},
	requestSubmittedDescription: {
		defaultMessage: 'Your request will show up in your project queues as a new work item.',
		description: 'The description shown in the flag when the request is submitted successfully',
		id: 'help-center.request-create-form.requestSubmittedDescription',
	},
	requestSubmittedAction: {
		defaultMessage: 'View work item',
		description: 'The link label to navigate user to newly created work item',
		id: 'help-center.request-create-form.requestSubmittedAction',
	},
	requestSubmittedFcfWarningTitle: {
		defaultMessage: 'Request submitted with exceptions',
		description: 'The message title shown in the flag when the request is submitted with warnings',
		id: 'help-center.request-create-form.requestSubmittedFcfWarningTitle',
	},
	requestSubmittedFcfWarningMessageDescription: {
		defaultMessage:
			'We submitted your request but without the value of the {field} field. If this happens again, notify your admin.',
		description:
			'The message description shown in the flag when the request is submitted with warnings',
		id: 'help-center.request-create-form.requestSubmittedFcfWarningMessageDescription',
	},
});
